import Dht11Diagram from "../../../../docs/_images/hw_ff_dht11.png";
import * as React from 'react';
export default {
  Dht11Diagram,
  React
};